import React, { createContext, useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import type { Lang, Localized } from "../types/i18n";
type LanguageContextValue = {
  lang: Lang;
  setLang: (next: Lang) => void;
  t: (value: Localized) => string;
};
type LanguageProviderProps = {
  lang: Lang;
  children: React.ReactNode;
};
const LanguageContext = createContext<LanguageContextValue | null>(null);
export function LanguageProvider({
  lang,
  children
}: LanguageProviderProps) {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((next: Lang) => {
    if (next === lang) return;
    navigate({
      pathname: next === "es" ? "/es" : "/en",
      hash: location.hash
    });
  }, [lang, navigate, location.hash]);
  const t = useCallback((value: Localized) => value[lang], [lang]);
  const value = useMemo(() => ({
    lang,
    setLang,
    t
  }), [lang, setLang, t]);
  return <LanguageContext.Provider value={value} data-id="element-411" data-mp="3hw2jkdyyzqrx">{children}</LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}